import { Bot, Sparkles, Smartphone } from "lucide-react";
import Reveal from "@/components/Reveal";
import PillarShowcase from "@/components/PillarShowcase";
import { ROBOSPARK_FILM } from "@/lib/api";

const STATS = [
  { icon: Bot, label: "20 humanoid models", testid: "robospark-stat-models" },
  { icon: Sparkles, label: "Serve · Clean · Secure · Assist", testid: "robospark-stat-skills" },
  { icon: Smartphone, label: "Orchestrated from the LuxeRay app", testid: "robospark-stat-app" },
];

/** RoboSpark hero strip on the Mart page: 30s humanoid showcase film with scene captions + fleet CTA. */
export default function RoboSparkSpotlight() {
  const scrollToFleet = () => document.querySelector('[data-testid="mart-robots-section"]')?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="py-16 px-6 bg-[#02050F] border-b border-white/10" data-testid="robospark-spotlight">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-4">
              <span className="font-mono-lbl text-xs text-[#FF1E8C] uppercase tracking-widest block mb-3">Humanoid Spotlight</span>
              <h2 className="font-disp text-4xl sm:text-5xl tracking-tight leading-[0.95] mb-4" data-testid="robospark-headline">
                RoboSpark<span className="block text-white/60 text-2xl sm:text-3xl mt-1">Humanoids on duty</span>
              </h2>
              <p className="text-white/70 text-sm mb-6">
                A 30-second look at the RoboSpark fleet — serving guests, caring for homes and keeping watch — every unit commanded from the LuxeRay Smart Homes app.
              </p>
              <ul className="space-y-2.5 mb-8">
                {STATS.map(({ icon: Icon, label, testid }) => (
                  <li key={testid} className="flex items-center gap-3 text-sm text-white/85" data-testid={testid}>
                    <span className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
                      <Icon className="w-4 h-4 text-[#00F0FF]" />
                    </span>
                    {label}
                  </li>
                ))}
              </ul>
              <button
                type="button"
                onClick={scrollToFleet}
                className="bg-[#FF2E2E] hover:bg-[#E01F1F] text-white px-6 py-3 rounded-lg font-mono-lbl text-xs uppercase tracking-wider font-bold shadow-lg shadow-black/30 transition-colors"
                data-testid="robospark-explore-btn"
              >
                Explore the fleet
              </button>
            </div>
            <div className="lg:col-span-8">
              <div className="relative aspect-video rounded-2xl overflow-hidden border border-white/10 bg-[#061536] group" data-testid="robospark-film">
                <PillarShowcase video={ROBOSPARK_FILM} captions={ROBOSPARK_FILM.captions} segment={ROBOSPARK_FILM.segment} label={ROBOSPARK_FILM.label} testid="robospark" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#02050F]/70 via-transparent to-transparent pointer-events-none" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
